import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  VehicleSpecificationCategory,
  VehicleSpecificationResponse,
  VehicleTechnicalSpecificationCategory,
  VehicleTechnicalSpecificationItem,
} from 'src/app/models/vehicle-order-specification.model';
import { VehicleOrderService } from 'src/app/services/vehicle-order/vehicle-order.service';

@Component({
  selector: 'app-vo-standard-vehicle-information',
  templateUrl: './vo-standard-vehicle-information.component.html',
  styleUrls: ['./vo-standard-vehicle-information.component.scss'],
  standalone: false
})
export class VoStandardVehicleInformationComponent {
  @Input() capId?: number;

  isLoading = false;
  loadFailed = false;
  standardEquipment: VehicleSpecificationCategory[] = [];
  technicalSpecification: VehicleTechnicalSpecificationCategory[] = [];

  constructor(
    private readonly modalCtrl: ModalController,
    private readonly vehicleOrderService: VehicleOrderService,
  ) { }

  ionViewWillEnter(): void {
    this.standardEquipment = [];
    this.technicalSpecification = [];
    this.loadFailed = false;
    this.isLoading = true;

    if (this.capId == null) {
      this.loadFailed = true;
      this.isLoading = false;
      return;
    }

    this.vehicleOrderService.getVehicleSpecification(this.capId).subscribe({
      next: (response) => {
        this.standardEquipment = this.mapStandardEquipment(response);
        this.technicalSpecification = this.mapTechnicalSpecification(response);
        this.isLoading = false;
      },
      error: () => {
        this.loadFailed = true;
        this.isLoading = false;
      }
    });
  }

  close() {
    this.modalCtrl.dismiss();
  }

  private mapStandardEquipment(response: VehicleSpecificationResponse): VehicleSpecificationCategory[] {
    return (response.standardEquipment ?? [])
      .map(category => ({
        category: category.category?.trim() ?? '',
        items: (category.items ?? [])
          .map(item => ({ name: item.name?.trim() ?? '' }))
          .filter(item => item.name)
      }))
      .filter(category => category.category && category.items.length > 0);
  }

  private mapTechnicalSpecification(response: VehicleSpecificationResponse): VehicleTechnicalSpecificationCategory[] {
    return (response.technicalSpecification ?? [])
      .map(category => ({
        category: category.category?.trim() ?? '',
        items: (category.items ?? [])
          .map(item => this.mapTechnicalSpecificationItem(item))
          .filter((item): item is VehicleTechnicalSpecificationItem => !!item)
      }))
      .filter(category => category.category && category.items.length > 0);
  }

  private mapTechnicalSpecificationItem(
    item: VehicleTechnicalSpecificationItem
  ): VehicleTechnicalSpecificationItem | null {
    const name = item.name?.trim() ?? '';
    const value = item.value?.trim() ?? '';

    if (!name || !value) {
      return null;
    }

    return { name, value };
  }
}
